import React from 'react';
import {IconProps} from './typing';

const SortArrow: React.FC<IconProps> = (props) => {
  const {iconSize} = props;
  return (
    <svg
      width={iconSize || '19'}
      height={iconSize || '15'}
      viewBox="0 0 19 15"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.11955 10.2925L0 11.4118L2.6071 14.018C2.91641 14.3273 3.41821 14.3273 3.72666 14.018L6.33342 11.4118L5.21387 10.2916L3.95843 11.5471V0H2.37499V11.5471L1.11955 10.2925Z"
        fill="currentColor"
      />
      <path
        d="M7.9165 1.5835H19.0001V3.16694H7.9165V1.5835Z"
        fill="currentColor"
      />
      <path d="M7.9165 4.75H16.6251V6.33344H7.9165V4.75Z" fill="currentColor" />
      <path
        d="M7.9165 7.91602H14.2501V9.49946H7.9165V7.91602Z"
        fill="currentColor"
      />
      <path
        d="M7.9165 11.0835H11.8749V12.6666H7.9165V11.0835Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SortArrow;
